<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <div class="article-wrap" style="height: 100%;">
        <div v-if="businessObj.id" class="centre_content nano" id="centre_contents">
          <!--          class="pl-3"-->
          <div id="consult_left_content">
            <div class="table-top-box">
              <span class="fl left">{{ $t('label.information.business.title') }}</span>
              <span class="fr right" @click="$router.back()">
                <Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />{{
                  $t('buttons.back')
                }}
              </span>
              <span class="fr right div-xs-hidden" @click="exportDetail"><span class="word-png"></span>{{
                $t('buttons.export')
              }}</span>
              <!-- <span class="fr right"><Icon type="md-star" style="font-size: 20px;"/></span> -->
              <span class="fr right">
                <Icon color="#008bce" @click="editFavorite"
                  :type="businessObj.favStatus ? 'md-star' : 'md-star-outline'" style="font-size: 20px;" />
              </span>
            </div>
          </div>
          <div class="nano-content p-4" id="spanblock" style="top:40px;padding-top: 0px !important;">
            <h1 class="information_article_headline">{{ businessObj.title | filterEmpty }}</h1>
            <p class="information_article_info">
              <span class="mr-2">{{ $t('label.information.detail.time') }}{{ businessObj.time | filterEmpty }} </span>
              <span v-if="businessObj.author && businessObj.author > 0">
                {{ $t('label.information.detail.author') }}
                <span class="mr-2">{{ businessObj.author | filterEmpty }} </span>
              </span>
              <span v-if="businessObj.sourceType">{{
                $t('label.information.detail.source')
              }}{{ businessObj.sourceType | filterEmpty }}</span>
            </p>
            <div class="information_article_abstract rounded" v-if="businessObj.summary">
              <p>{{ $t('label.information.detail.summary') }}{{ businessObj.summary }}</p>
            </div>
            <!-- 文章 -->
            <div class="information_article_details text-indent2" v-html="`${businessObj.content}`">
            </div>
            <p class="pbr-detail-box-link">
              <!-- businessObj.sourceLink -->
              <el-link type="primary" target="_blank" :underline="false"
                v-if="isSourceAddressValidate(businessObj.sourceAddress)" @click="copySourceAddress">
                {{ $t('label.information.detail.originalLink') }}
              </el-link>
              <template v-if="!businessObj.isOrigin">
                <el-link type="primary" :underline="false" @click="fetchOrigin">
                  {{ $t('label.information.detail.originalDetails') }}
                </el-link>
              </template>
              <template v-if="isTranslate">
                <el-link type="primary" :underline="false" @click="fetchtranslation">
                  {{ $t('label.information.detail.translatedDetails') }}
                </el-link>
              </template>
            </p>
            <p v-if="!businessObj.isOrigin" class="information_article_info">
              {{ $t('message.info.articleTranslateHint') }}
            </p>
          </div>
        </div>
      </div>
      <!--      <div class="table-top-box">-->
      <!--        <span class="fl left">商机详情</span>-->
      <!--        <span class="fr right" @click="$router.back()"><Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />返回</span>-->
      <!--        <span class="fr right" @click="exportDetail"><span class="pdf-back"></span>导出PDF</span>-->
      <!--        <span class="fr right"><Icon color="#008bce" @click="editFavorite" :type="businessObj.favStatus ? 'md-star' : 'md-star-outline'" style="font-size: 20px;"/></span>-->
      <!--      </div>-->
      <!--      <div class="pbr-detail-box">-->
      <!--        &lt;!&ndash; businessObj.title &ndash;&gt;-->
      <!--        <h3 class="pbr-detail-box-title">{{businessObj.title|filterEmpty}}</h3>-->
      <!--        &lt;!&ndash; businessObj.time author source  &ndash;&gt;-->
      <!--        <p class="pbr-detail-box-author">-->
      <!--          <span>{{businessObj.time|filterEmpty}}</span>-->
      <!--          <span>作者：{{businessObj.author|filterEmpty}}</span>-->
      <!--          <span>来源：{{businessObj.source|filterEmpty}}</span>-->
      <!--        </p>-->
      <!--        &lt;!&ndash; summary &ndash;&gt;-->
      <!--        <p class="pbr-detail-box-summary">【摘要】{{businessObj.summary|filterEmpty}}</p>-->
      <!--       &lt;!&ndash; labels &ndash;&gt;-->
      <!--        <p class="pbr-detail-box-tags">-->
      <!--          <el-tag-->
      <!--            style="margin-right: 4px;"-->
      <!--            v-for="item in businessObj.labels"-->
      <!--            :key="item"-->
      <!--            size="small"-->
      <!--            effect="plain">-->
      <!--            {{ item }}-->
      <!--          </el-tag>-->
      <!--        </p>-->
      <!--        &lt;!&ndash; content &ndash;&gt;-->
      <!--        &lt;!&ndash; <p class="pbr-detail-box-img">-->
      <!--          <img src="../common/img/detail.jpg" alt="">-->
      <!--        </p> &ndash;&gt;-->
      <!--        <p class="pbr-detail-box-content" v-html="clearSymbol(businessObj.content)"></p>-->
      <!--        <p class="pbr-detail-box-link">-->
      <!--           &lt;!&ndash; businessObj.sourceLink &ndash;&gt;-->
      <!--           <a v-if="isSourceAddressValidate(businessObj.sourceLink )" :href="businessObj.sourceLink">原文链接</a>-->
      <!--         &lt;!&ndash; businessObj.source &ndash;&gt;-->
      <!--         <el-link type="primary" :underline="false" @click="fetchOrigin" v-if="!isOrigin">原文详情</el-link>-->
      <!--        </p>-->
      <!--      </div>-->
    </div>
    <div class="wrap-box-right">
      <div>
        <!-- projectModels -->
        <div class="pbr-title">{{ $t('label.information.business.relatedItems') }}</div>
        <normal-list :data="projectModels" goto="pbrProjectDetail"></normal-list>
      </div>
      <div>
        <!-- articleModels -->
        <div class="pbr-title">{{ $t('label.information.detail.relevantInformation') }}</div>
        <normal-list :data="articleModels" goto="pbrInfoDetail"></normal-list>
      </div>
    </div>
    <div v-show="false" ref="submitForm">
      <form method="get" target="_blank" enctype="multipart/form-data" :action="action">
        <input name="id" type="text" />
        <input name="from" type="text" value="cn" />
      </form>
    </div>
  </div>
</template>

<script>
import NormalList from '../index/NormalList.vue'
import { contentType, exportFile } from '../apis/common'

export default {
  name: 'pbrBusinessDetail',
  components: { NormalList },
  inject: ['copyToPasteBoard'],
  data() {
    return {
      isTranslate: false,
      isOrigin: false,
      articleModels: [],
      projectModels: [],
      businessObj: {},
      tags: [
        { label: '德国' },
        { label: '国际文化经济交流项目' },
        { label: '巴伐利亚州' }
      ],
      action: this.$pbrApis.exportInfoDetailWordUrl
    }
  },
  created() {

    if (this.$route.query.key) {
      this.fetchDetail()
      this.fetchBusinessRinfos()
    } else {
      this.$router.replace({ name: 'pbrInfo' })
    }
  },
  mounted() {
  },
  activated() {
    this.isTranslate = false
    if (this.$route.query.key) {
      this.fetchDetail()
      this.fetchBusinessRinfos()
    } else {

      // this.$iMessage.error({
      //   content: this.$t('message.warning.noId'), duration: 5, onClose: () => {
      //     this.$router.replace({name: 'pbrInfo'})
      //   }
      // })
    }
  },
  methods: {
    clearSymbol(content) {
      if (content && content.length > 0) {
        return content.replace(/[?？]{2,}/g, '').replace(/\n+/g, '\n')
      }
      return '--'
    },
    fetchOrigin() {
      this.isTranslate = true
      // this.isOrigin = true
      this.fetchDetail({ isOrigin: 1 })
    },
    fetchtranslation() {
      this.isTranslate = false
      // this.isOrigin = true
      this.fetchDetail()
    },
    fetchDetail(p) {
      this.businessObj = {}
      if (!this.$route.query.key) {
        return
      }
      let params = {
        id: this.$route.query.key,
        lang: 'cn',
        ...p
      }
      this.$pbrApis.queryInfoDetail({ params: params }).then(res => {
        console.log('项目资讯详情', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.businessObj = res.result || {}
          this.isTranslate = p.isOrigin ? true : fals

          if (!this.businessObj || !this.businessObj.hasOwnProperty('favStatus')) {
            // this.$iMessage.warning({
            //   content: this.$t('message.warning.information.noData'),
            //   duration: 5,
            //   closable: true,
            //   onClose: () => {
            //     this.$router.replace({name: 'pbrInfo'})
            //   }
            // })
          }
        }
      })
    },
    fetchBusinessDetail() {
      this.businessObj = {}
      if (!this.$route.query.key) {
        return
      }
      // this.$route.query.key
      this.$pbrApis.fetchBusinessDetail({ id: this.$route.query.key, from: 'cn' }).then(res => {
        console.log('商机资讯详情', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.businessObj = res.result || {}
        }
      })
    },
    fetchBusinessRinfos() {
      this.articleModels = []
      this.projectModels = []
      if (!this.$route.query.key) {
        return
      }

      // '1416297066990886914'
      // this.$route.query.key
      this.$pbrApis.fetchBusinessRinfos({ id: this.$route.query.key, from: 'cn' }).then(res => {
        console.log('商机相关资讯', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.articleModels = res.result.articleModels
          this.projectModels = res.result.projectModels
        } else {
          this.$router.replace({ name: 'pbrInfo' })
        }
      })
    },
    addBusinessDetailReadTimes() {
      this.$pbrApis.addBusinessDetailReadTimes({ id: this.$route.query.key }).then(res => {
        console.log('商机详情阅读次数', res)
        if (!res) {

        } else if (res.success) {

        }
      })
    },
    editFavorite() {
      if (!this.$route.query.key) {
        //this.$iMessage.error({content: this.$t('message.warning.noFavorite'), duration: 5})
        return
      }
      let type = this.businessObj.favStatus ? 'delete' : 'add'
      // this.businessObj.id
      this.$pbrApis.editFavorite(type, { id: this.$route.query.key, type: 5 }).then(res => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.favorite'), duration: 5})
        } else if (res.code === 200) {
          console.log('收藏', res)
          // this.$iMessage.success({
          //   content: type === 'add' ? this.$t('message.success.favorite') : this.$t('message.success.unfavored'),
          //   duration: 5
          // })
          this.fetchDetail()
        }
      }).catch(err => {
        //this.$iMessage.error({content: err.message, duration: 5})
      })
    },
    isSourceAddressValidate(value) {
      return value && value.length > 0 && value !== 'null'
    },
    exportDetail() {
      // let form = $(this.$refs.submitForm).find('form');
      // form.find("input[name='id']").val(this.$route.query.key);
      // form.submit();
      exportFile(this.action, { id: this.$route.query.key }, this.$t('label.export.info') + this.businessObj.title, contentType.word, '.docx')
    },
    copySourceAddress() {
      this.copyToPasteBoard(this.businessObj.sourceAddress)
    }
  },
  watch: {
    '$store.state.brpaModule.hideContainer': {
      handler(n, o) {
        if (n) {
          document.querySelector('.pbr-box #centre_contents') && document.querySelector('.pbr-box #centre_contents').setAttribute('style', 'height: calc(100vh - 80px) !important');
        } else {
          document.querySelector('.pbr-box #centre_contents') && document.querySelector('.pbr-box #centre_contents').setAttribute('style', '');
        }
      },
      immediate: true
    },
  },
  filters: {
    filterEmpty: function (value) {
      if (!value || value.length === 0) {
        return '--'
      }
      return value
    },
    filterSymbol: (value) => {
      if (value && value.length > 0) {
        return value.replace(/[?？]{2,}/g, '').replace(/\n+/g, '\n')
      }
      return '--'
    }
  }

}
</script>
<style scoped></style>
